

















import { mapGetters } from 'vuex';

export default {
	name: 'CharacterCard',

	props: {
		characterId: String
	},

	computed: {
		...mapGetters(['characterById', 'getLanguage'])
	}
};
